export enum BLOCK_SIZE {
    S = 's',
    M = 'm',
    L = 'l',
    XL = 'xl',
}

export enum MAIN_ITEM_IMAGE_POSITION {
    BOTTOM_LEFT = 'bottom-left',
    TOP_RIGHT = 'top-right',
}

export enum MAIN_ITEM_ITEMS_DIRECTION {
    ROW = 'row',
    COLUMN = 'column',
}

export interface ContentShowcaseWidgetInnerItemData {
    icon?: string;
}

export interface ContentShowcaseWidgetData {
    title: string | null;
    items: ContentShowcaseWidgetItemData[];
}

export interface ContentShowcaseWidgetItemData {
    name: string;
    description?: string;
    items: ContentShowcaseWidgetInnerItemData[];
    originalData?: unknown;
    visualSettings?: {
        backgroundColor?: string;
        backgroundImage?: string;
        image?: string;
        colors?: (string | null)[];
        imagePosition?: MAIN_ITEM_IMAGE_POSITION;
        direction?: MAIN_ITEM_ITEMS_DIRECTION;
    };
}
